import { fork, all } from 'redux-saga/effects';

import propertyObjectTitleReducer from './propertyObjectTitle/reducer';
import propertyObjectTitleSaga from './propertyObjectTitle/saga';

import editedFormulaReducer from './formula/reducer';

export const propertyObjectsReducers = {
  propertyObjectTitle: propertyObjectTitleReducer,
  editedFormulaId: editedFormulaReducer,
};

export function* propertyObjectsSagas() {
  yield all(
    [propertyObjectTitleSaga].map(function (saga) {
      return fork(saga);
    }),
  );
}
